<template>
	<el-container>
		<el-header>
			<mainpay v-if="showpay" v-on:payok="payok" :inOrderID='morderid' :inOrderDesc='OrderDesc' :inAmount='sum'></mainpay>
			<el-button v-if="showbook" type="success" round @click="tobook()">去预约</el-button>
		</el-header>
		<div style="margin-top: 5px;">
			<el-row>
				<el-col :span="24">
					<span class="spanlabel">总计：</span>
					<span class="spantxt">￥{{sum}}</span>
				</el-col>
				</el-row>
			<el-row>
				<el-col :span="24" v-for="li in morderdetaillist">
					<div style="margin-top: 5px;">
						<ul style="width: 60%;float: left;">
							<li>
								{{li.goods_name}}
							</li>
						</ul>
						<ul style="width: 40%;float: right;">
							<li>
								<span class="spanlabel">单价：￥{{li.goods_saleprice}}</span>
								<span class="spantxt">X{{li.goods_count}}</span>
							</li>
						</ul>
					</div>
				</el-col>
			</el-row>
		</div>

	</el-container>
</template>

<script>
	import member from '../../apifunction/Member.js'
	import mainpay from '../OnlinePay/morderpay.vue'
	export default {
		created() {
			this.userent = this.$myglobal.getUserInfo();
			this.morderid = this.$route.query.ent;
			this.ShowMOrderDetail();
		},
		components: {
			mainpay
		},
		provide() {
			return {
				payok: this.payok
			}
		},
		data() {
			return {
				morderid: '',
				OrderDesc: '体检套餐',
				userent: null,
				morderdetaillist: [],
				showbook: false,
				showpay: true,
				sum: 0
			}
		},
		methods: {
			payok() {
				this.showbook = true;
				this.showpay = false;
				this.$forceUpdate()
			},
			tobook: function() {
				var data = {
					path: '/BookCusList',
					query: {
						mobile: this.userent.mobile
					}
				};
				this.$router.push(data)

			},
			ShowMOrderDetail() {
				member.GetShopOrderByID(this.morderid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								let morderent = JSON.parse(ent.Data)[0];
								if (morderent.orderstatus == 0) {
									// this.showbook = false;
									// this.showpay = true;
								} else {
									this.showbook = true;
									this.showpay = false;
								}
							}
						}
					});

				member.GetShopOrderDetailByID(this.morderid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								let getdata = JSON.parse(ent.Data);
								let templist = []
								let tempsum = 0;
								let lastid = '';
								let count = 1;
								for (let i = 0; i < getdata.length; i++) {
									tempsum += getdata[i].goods_saleprice
									if (lastid != getdata[i].goods_id) {
										lastid = getdata[i].goods_id;
										getdata[i].goods_count = 1;
										templist.push(getdata[i])
									} else {
										templist[templist.length - 1].goods_count++;
									}
								}
								this.morderdetaillist = templist;
								this.sum = tempsum;
							}

						} else
							this.$message.info(ent.Msg);
					})
			}

		}
	}
</script>

<style>
</style>
